import React from 'react';
import Icon from '../Icon';
import Eyebrow from '../page/Eyebrow';
import { tie } from '../page/typography';

/**
 * Зміст статті: розділи-якорі, а під «Що робити» — обидва сценарії окремо.
 *
 * Сценарії винесені в зміст, бо саме по них людина шукає своє: хто вже
 * подав Відомості, тому перші чотири кроки не потрібні зовсім.
 *
 * Звичайні <a href="#…">, без стану в React: працює ще до завантаження JS, а
 * прокрутку до розділу робить браузер. Липкість задає сторінка, а не цей
 * блок — на телефоні зміст стоїть звичайним блоком перед текстом.
 */
const linkClass =
  'group flex items-start gap-3 rounded-lg px-3 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 transition-colors duration-200';

const ArticleToc = ({ id = 'zmist', sections, className = '' }) => (
  <nav aria-labelledby={`${id}-title`} className={`rounded-2xl border border-slate-200 bg-slate-50 p-3 sm:p-4 lg:p-3 ${className}`}>
    <Eyebrow as="h2" id={`${id}-title`} className="px-3 pt-2 pb-2">
      Зміст статті
    </Eyebrow>
    <ol className="list-none m-0 p-0">
      {sections.map((section) => (
        <li key={section.id}>
          {/* Мишею в рядок 36px влучити легко; на дотик — 44px. */}
          <a href={`#${section.id}`} className={`${linkClass} min-h-[2.75rem] lg:min-h-[2.25rem] py-2.5 lg:py-2`}>
            <Icon
              name="fa-arrow-right"
              className="mt-[0.3rem] flex-shrink-0 rotate-90 text-[0.7rem] text-teal-700 transition-transform duration-200 motion-reduce:transition-none group-hover:translate-y-0.5"
            />
            <span className="text-[0.95rem] lg:text-sm font-medium leading-snug text-balance text-slate-800 group-hover:text-teal-800 transition-colors duration-200">
              {tie(section.title)}
            </span>
          </a>
          {section.children && (
            <ol className="list-none m-0 p-0 ml-[1.4rem] mb-1 border-l border-slate-200">
              {section.children.map((child) => (
                <li key={child.id}>
                  <a href={`#${child.id}`} className={`${linkClass} ml-2 min-h-[2.75rem] lg:min-h-[2rem] py-2.5 lg:py-1.5`}>
                    <span className="text-[0.9rem] lg:text-[0.8125rem] leading-snug text-slate-600 group-hover:text-teal-800 transition-colors duration-200">
                      {tie(child.title)}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default ArticleToc;
